import React from 'react'
import Link from 'next/link'
import Head from 'components/Head'
import SiteLayout from 'components/SiteLayout'
import SigninForm from 'components/SigninForm'
import { usePageView } from 'hooks'
import { getStaticWrapper } from 'utils'

const SigninPage = () => {
  usePageView()
  return (
    <>
      <SiteLayout>
        <Head title='Sign In | Barstool Sports' noIndexNoFollow />
        <div className='container container--accountInfoFlow'>
          <h1 className='title'>Join Now or Login</h1>
          <p className='subtitle'>Enter your email address.</p>
          <SigninForm />
          <p className='finePrint'>
            By submitting this form I agree to this site's{' '}
            <Link href='/terms-of-use'>
              <a>Terms of Use</a>
            </Link>
            {' and '}
            <Link href='/privacy-policy'>
              <a>Privacy Policy</a>
            </Link>
            .
          </p>
        </div>
      </SiteLayout>
      <style jsx>{`
        .finePrint {
          text-align: left;
          margin: auto;
          padding: 0 0 1rem;
          max-width: 16rem;
          font-size: 0.75rem;
          color: #999;
          font-weight: 400;
        }
        .subtitle {
          font-size: 1rem;
          margin-top: 0;
        }
        input {
          margin: auto;
          max-width: 16rem;
        }
        button {
          margin: auto;
          max-width: 16rem;
        }
        h1 + p {
          margin-top: -0.5rem;
          margin-bottom: 24px;
        }
        a {
          color: blue;
          font-weight: normal;
        }
      `}</style>
    </>
  )
}

export const getStaticProps = getStaticWrapper()

export default SigninPage
